<template>
  <div class="relative"></div>
  <div class="h-80 bg-bgheader absolute w-full"></div>

  <div class="absolute w-full">
    <div class="flex flex-col justify-center">
      <h1 class="text-right text-lg font-bold mb-3 pt-9 mr-2 text-white">
        لیست برنامه ها
      </h1>
      <div class="flex flex-row">
        <input
          class="border text-center p-2 rounded-lg text-cyan-900 bg-white shadow-lg mt-8 mr-4 w-4/5 ml-1"
          type="text"
          placeholder="جستجو ..."
          v-model="this.vlaSearch"
        />
        <div
          class="flex justify-center py-1 px-2 mt-8 bg-bgbutton border border-yellow-500 rounded-xl shadow-md"
          @click="search"
        >
          <font-awesome-icon
            icon="magnifying-glass"
            class="fa-xl text-bgfont mt-1"
          />
        </div>
      </div>
    </div>
    <div
      class="grid grid-cols-3 gap-1 mx-4 my-8 text-xs font-bold"
      id="listtask"
    >
      <button
        class="flex justify-center bg-bghover py-2 rounded-3xl text-white border border-red-800 shadow-lg"
        type="button"
        id="ytask"
        @click="Task('ytask')"
      >
        <span class="mr-2">دیروز</span>
      </button>
      <button
        class="flex justify-center bg-bgbutton py-2 rounded-3xl text-cyan-900 border border-yellow-600 shadow-lg"
        type="button"
        id="ttask"
        @click="Task('ttask')"
      >
        <span class="mr-2">امروز</span>
      </button>
      <button
        class="flex justify-center bg-bgbutton py-2 rounded-3xl text-cyan-900 border border-yellow-600 shadow-lg"
        type="button"
        id="totask"
        @click="Task('totask')"
      >
        <span class="mr-2">فردا</span>
      </button>
    </div>
    <div
      class="flex flex-row justify-center text-xs font-bold my-4"
      v-if="status.length != 0"
    >
      <div @click="filterdata(-1)">
        <font-awesome-icon
          icon="filter-circle-xmark"
          class="fa-xl text-white"
        />
        <span class="text-sm text-slate-200 font-bold">همه</span>
      </div>
      <div @click="filterdata(0)">
        <font-awesome-icon
          icon="circle-exclamation"
          class="fa-xl text-bgbutton mr-3"
        />
        <span class="text-sm text-slate-200 font-bold"> بدون اقدام </span>
      </div>
      <div @click="filterdata(1)">
        <font-awesome-icon
          icon="circle-check"
          class="fa-xl text-green-500 mr-3"
        />
        <span class="text-sm text-slate-200 font-bold">مراجعه شده</span>
      </div>
      <div @click="filterdata(2)">
        <font-awesome-icon icon="xmark" class="fa-xl text-bgfont mr-3" />
        <span class="text-sm text-slate-200 font-bold">بسته</span>
      </div>
    </div>
    <div v-if="result.length != 0" class="mb-24">
      <TaskCard v-for="task in result" :key="task.id" :task="task" />
    </div>
    <div
      class="block bg-white rounded-2xl px-4 py-11 border text-cyan-900 text-center text-lg mt-4 mx-4 shadow-lg h-36"
      v-else
    >
      <span class="text-red-800 font-bold">داده ای برای نمایش وجود ندارد</span>
    </div>
    <!-- <v-pagination
      v-model="pagination.PageNumber"
      :pages="pagination.TotalPages"
      :range-size="1"
      active-color=""
      @update:modelValue="getShops"
    /> -->
  </div>
</template>

<script>
import { schedule, getStatus } from "@/API/API";
import TaskCard from "../components/TaskCard.vue";
// import VPagination from "@hennge/vue3-pagination";
// import "../assets/css/pagination.css";
export default {
  name: "TaskPage",
  components: { TaskCard },
  data() {
    return {
      requests: [],
      yesterdaySchedule: [],
      nowSchedule: [],
      tomorrowSchedule: [],
      result: [],
      pagination: {},
      status: [],
      selecterTask: "",
      vlaSearch: "",
    };
  },
  async created() {
    this.getTask();
    this.loading = false;
    this.getStatus();
    this.selecterTask = "ytask";
  },
  methods: {
    Task(id) {
      this.selecterTask = id;
      let lstTsk = document.getElementById("listtask").children;
      for (let i = 0; i < lstTsk.length; i++) {
        lstTsk.item(i).classList.remove("bg-bghover");
        lstTsk.item(i).classList.remove("border-red-800");
        lstTsk.item(i).classList.add("bg-bgbutton");
        lstTsk.item(i).classList.remove("text-white");
      }
      document.getElementById(id).classList.remove("bg-bgbutton");
      document.getElementById(id).classList.add("bg-bghover");
      document.getElementById(id).classList.remove("border-yellow-600");
      document.getElementById(id).classList.add("border-red-800");
      document.getElementById(id).classList.remove("text-cyan-900");
      document.getElementById(id).classList.add("text-white");

      if (id == "ytask") {
        this.result = this.yesterdaySchedule;
        this.$store.dispatch("insertDetail", this.result);
      } else if (id == "ttask") {
        this.result = this.nowSchedule;
        this.$store.dispatch("insertDetail", this.result);
      } else if (id == "totask") {
        this.result = this.tomorrowSchedule;
        this.$store.dispatch("insertDetail", this.result);
      }
    },
    async getTask() {
      if (this.selecterTask == "ytask") {
        this.result = this.yesterdaySchedule;
        this.$store.dispatch("insertDetail", this.result);
      }
      this.requests = (await schedule(this.vlaSearch)).data.result;
      this.yesterdaySchedule = this.requests.yesterdaySchedule;
      this.nowSchedule = this.requests.nowSchedule;
      this.tomorrowSchedule = this.requests.tomorrowSchedule;
      this.result = this.yesterdaySchedule;
      this.$store.dispatch("insertDetail", this.result);
    },
    selectAnbar(id) {
      this.modalAnbar = true;
      this.selectedCustomer = id;
    },
    async getStatus() {
      this.status = (await getStatus()).data.result;
    },
    async filterdata(id) {
      this.requests = (await schedule()).data.result;
      const idtask = this.selecterTask;
      if (idtask == "ttask") {
        this.result = this.requests.nowSchedule;
        if (id == -1) {
          this.result = this.requests.nowSchedule;
        } else {
          this.result = this.result.filter((item) => {
            return item.scheduleStatusId == id;
          });
        }
      } else if (idtask == "ytask") {
        this.result = this.requests.yesterdaySchedule;
        if (id == -1) {
          this.result = this.requests.yesterdaySchedule;
        } else {
          this.result = this.result.filter((item) => {
            return item.scheduleStatusId == id;
          });
        }
      } else if (idtask == "totask") {
        this.result = this.requests.tomorrowSchedule;
        if (id == -1) {
          this.result = this.requests.tomorrowSchedule;
        } else {
          this.result = this.result.filter((item) => {
            return item.scheduleStatusId == id;
          });
        }
      }
    },
  },
};
</script>
